import useRtl from "src/hooks/useRtl";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { Dispatch, SetStateAction } from "react";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";

interface ModalButtonsProps {
  setOpen: Dispatch<SetStateAction<boolean>>;
  setReviewStep: Dispatch<SetStateAction<number>>;
  renderBackButton: boolean;
}

const ModalButtons = ({
  setOpen,
  setReviewStep,
  renderBackButton,
}: ModalButtonsProps) => {
  const isRtl = useRtl();
  // const renderBackButton = reviewStep > 0;
  if (renderBackButton)
    return (
      <div className="sticky top-1 flex w-full justify-between">
        <button
          type="button"
          onClick={() => setReviewStep((prevStep) => prevStep - 1)}
        >
          {isRtl ? (
            <ChevronRightIcon className="w-8" />
          ) : (
            <ChevronLeftIcon className="w-8" />
          )}
        </button>

        <button type="button" onClick={() => setOpen(false)}>
          <XMarkIcon className="w-8" />
        </button>
      </div>
    );
  else
    return (
      <div className="sticky top-1 flex w-full justify-end">
        <button type="button" onClick={() => setOpen(false)}>
          <XMarkIcon className="w-8" />
        </button>
      </div>
    );
};

export default ModalButtons;
